import {API, Setup} from '../../Services';

async function EventDetailData(eventId){
    let mallId= localStorage.getItem('mallId');
    const token = localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_posts/${eventId}`,{
        params:{post_type:"event"},
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function ServiceDetail_api(eventId){
    let mallId= localStorage.getItem('mallId');
    const token = localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_posts/${eventId}`,{
        params:{post_type:"service"},
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function ServiceDetail_old_api(id){
    let mallId =  localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/service_pages/${id}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


export {EventDetailData,ServiceDetail_api};
